// "City, ST 12345" or "City, ST 12345-6789" at the end of a formatted address.
const STATE_IN_LOCATION = /,\s*([A-Za-z]{2})\s+\d{5}(?:-\d{4})?\b/;

// Some inventory rows come back with a blank State/City even though Location
// is a full address, so read the state from Location when the field is empty.
export const stateOfProperty = (property) => {
  const direct = (property?.State || "").toString().trim().toUpperCase();
  if (direct) return direct;
  const match = STATE_IN_LOCATION.exec(property?.Location || "");
  return match ? match[1].toUpperCase() : "";
};

// Whether a property belongs in a tenant scoped to `allowedStates`. A property
// whose state cannot be determined is kept: it is the agent's own, and
// dropping it made its Matches pill unable to select anything.
export const isInAllowedStates = (property, allowedStates) => {
  if (!allowedStates?.length) return true;
  const state = stateOfProperty(property);
  if (!state) return true;
  return allowedStates.some((s) => String(s).toUpperCase() === state);
};
